import { render, staticRenderFns } from "./NVDModalTabs.vue?vue&type=template&id=2c54a6de&"
import script from "./NVDModalTabs.vue?vue&type=script&lang=ts&"
export * from "./NVDModalTabs.vue?vue&type=script&lang=ts&"
import style0 from "./NVDModalTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports